import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, homeFor } from "@/context/AuthContext";

export const FullLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center" data-testid="page-loader">
    <Loader2 className="h-6 w-6 animate-spin text-amber-500" />
  </div>
);

export default function ProtectedRoute({ roles, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user)} replace />;
  return children;
}
